// autogenerated, do not modify

export default {
  "Axios.ConnectionError": "没有联网。请检查您的联网设置以及APN（接入点）的设置（您需要将APN设为“internet”)。",
  "Axios.Error": "错误 {status}。",
  "Axios.ServerError": "系统错误。我们正努力解决这个问题。请稍后重试。",
  "Axios.TimeoutError": "服务器超时。请稍后重试。",
  "Common.Activate": "激活",
  "Common.Activated": "已激活",
  "Common.AddNumberForSMS": "添加一个MTX号码",
  "Common.Attention": "注意！",
  "Common.Back": "返回",
  "Common.Balance": "余额",
  "Common.CNY": "元",
  "Common.Cancel": "取消",
  "Common.Close": "关闭",
  "Common.ContactSupport": "联系客服",
  "Common.Date": "日期",
  "Common.Deactivate": "停用",
  "Common.Delete": "删除",
  "Common.Duration": "时长",
  "Common.ESIM": "eSIM",
  "Common.EUR": "€",
  "Common.Europe": "欧洲",
  "Common.Everywhere": "全部",
  "Common.Friday": "周五",
  "Common.IdentityUnverified": "您需要上载您的身份证件图片（护照、身份证或驾照 - 文字必须是拉丁字母）；您上载的图片文件需要通过审核后您才可以开始使用服务。",
  "Common.IdentityWanted": "您必须上传您的身份证件图片（护照、身份证或驾照）",
  "Common.IdentityWantedFlashMessage": "您必须<a href=\"{link}\">上传</a>您的身份证件图片（护照、身份证或驾照）",
  "Common.Loading": "加载...",
  "Common.Login": "登录",
  "Common.MB": "MB",
  "Common.Mb": "Mb",
  "Common.Monday": "周一",
  "Common.Name": "姓名",
  "Common.Next": "下一步",
  "Common.NoData": "无数据",
  "Common.Ok": "好",
  "Common.Package": "套餐",
  "Common.Price": "价格",
  "Common.SIM": "SIM",
  "Common.Saturday": "周六",
  "Common.Save": "保存",
  "Common.Simcard": "SIM卡",
  "Common.Sum": "总计",
  "Common.Sunday": "周日",
  "Common.Thursday": "周四",
  "Common.Traffic": "流量",
  "Common.Tuesday": "周二",
  "Common.Wednesday": "周三",
  "Common.day": "天",
  "Common.hour": "小时",
  "Common.minute": "分钟",
  "Exception.LetUsKnow": "联系我们",
  "Exception.PageNotFound": "找不到页面。404",
  "Exception.ReturnToHomepage": "返回首页",
  "Exception.ServerErrorDescription": "再试一次，若还不成功，请联系我们。",
  "Exception.ServerErrorTitle": "出了些问题。",
  "GDPR.AgreeBtn": "同意",
  "GDPR.Attention": "若您拒绝接受我们新的隐私条例，根据欧盟的最新法案，我们将无法为您提供服务。",
  "GDPR.BackLink": "回到MTX Connect 页面。",
  "GDPR.DisagreeBtn": "不同意",
  "GDPR.Notice": "遵循最新欧盟数据保护法案的要求，我们更新了我们的隐私条例，以便以更高标准来保护我们用户的隐私，并提高您所有个人数据的安全性。这些更新将帮助您理解哪些信息会从您这里获取以及获取的原因；同时也方便您了解如何管理、更新、删除或导出您的信息。",
  "GDPR.NoticeLink": "our Privacy Policy",
  "GDPR.Request": "我们恳请您仔细阅读我们更新的隐私条例，然后点击以下按键表示同意。",
  "GDPR.RequestLink": "our amended Privacy Policy",
  "GDPR.VerificationTitle": "感谢您的许可。",
  "History.All": "所有",
  "History.Date": "日期",
  "History.Details": "细节",
  "History.DownloadReceipt": "get receipt",
  "History.EmptyHistory": "无支付记录",
  "History.EndDate": "结束日期",
  "History.StartDate": "开始日期",
  "History.Sum": "总计",
  "LogoutButton.Logout": "登出",
  "LogoutButton.LogoutCancel": "取消",
  "LogoutButton.LogoutConfirmation": "登出？",
  "LogoutButton.LogoutYes": "是",
  "Menu.ActivateSIM": "添加新的SIM卡",
  "Menu.Connect": "联网",
  "Menu.ContactUs": "联系我们",
  "Menu.Coverage": "覆盖区域",
  "Menu.Faq": "常见问题",
  "Menu.History": "历史纪录",
  "Menu.HowItWorks": "如何使用",
  "Menu.Overview": "概要",
  "Menu.Pricing": "价格",
  "Menu.Profile": "个人信息",
  "Menu.Support": "援助",
  "Menu.Topups": "充值",
  "OneTIme.PaymentSuccess": "Payment successful.",
  "OneTime.Amount": "Amount",
  "OneTime.EsimSentTo": "eSIM settings were also sent to:",
  "OneTime.OrderID": "Order ID:",
  "OneTime.PaidWith": "Paid with",
  "OneTime.ThankYou": "Thank you for purchasing!",
  "OneTime.WaitingEsim": "Your eSIM installation QR code will be ready in 1-2 minutes",
  "OneTimePassBuyTitle": "You are going to buy One-Time Pass offer: <b>{name}</b>",
  "OneTimePassDescription": "This eSIM is for **one-time use only**. It will deactivate once its package is used up or expires, and it cannot be reused like a regular MTX eSIM.\n\nIt won't be visible in your MTX personal account, meaning you can't manage it there.\n\n\\\n**How to use One-time Pass:**\n1. You will get a QR code.\n2. Scan it with your phone.\n3. Follow the on-screen instructions.",
  "OneTimePassDisclaimerMsg": "New disposable eSIM will be installed. It will deactivate once it's used or expired.",
  "OneTimePassDisclaimerTitle": "ONE-TIME PASS OFFERS",
  "OneTimePassLoadingMsg": "We are looking for available One-Time offers, which can take up to 2 minutes. Please be patient.",
  "OneTimePassMissingCoverage": "We are constantly working to expand our coverage. Unfortunately, we currently do not have One-Time Pass offers in {country}.",
  "Order.Acknowledge": "Acknowledge",
  "Order.Activate": "激活一张新的SIM卡",
  "Order.ActivationCode": "激活码",
  "Order.Attention": "注意！您需要先充值以使用该服务。",
  "Order.AttentionCanada": "Attention: MTX Connect service cannot be used for domestic service in Canada by residents of Canada.",
  "Order.AttentionChina": "递送到中国大陆的订单，请您务必提供您的手机号码以及您的中文收件地址。",
  "Order.CartCaption": "您订购了 {amount} {name} 卡, 总价为 €{price}*",
  "Order.ChooseOption": "选择一个选项",
  "Order.ChooseType": "选择SIM卡种类",
  "Order.CloseBtn": "关闭",
  "Order.Continue": "若继续，您则表示同意我们的<a href=\"https://www.mtxc.eu/en/terms-and-conditions.html\" target=\"_blank\">条款</a>以及<a href=\"https://www.mtxc.eu/en/privacy-policy.html\" target=\"_blank\">隐私政策</a>。",
  "Order.DontDeleteEsim": "警告！请不要删除您的eSIM, 已删除的eSIM是无法恢复的。您可临时停止您的账户，在需要的时候再重新激活账户。",
  "Order.DontDeleteEsimLink": "https://mtxchelp.crisp.help/en-us/article/what-do-i-do-if-i-delete-my-esim-tagfxh/",
  "Order.DontDeleteEsimLinkName": "(常见问题)",
  "Order.ESIMConfirmation": "我确认我的设备支持eSIM。",
  "Order.ESIMDescr": "用于您的eSIM设备的eSIM价格€{price}",
  "Order.EsimCanProcess": "eSIM 下载需要不超过2分钟的时间。",
  "Order.EsimRequestRateExceeded": "您已超过每两分钟只能下一个订单的规定。若需要预定更多，请您稍等片刻。",
  "Order.EsimSent": "eSIM 的设置也会发送到您的电子邮箱，这个窗口可关闭了。",
  "Order.MakeSureEsim": "请确保您的智能手机或其他移动设备支持eSIM！请查询你的设备的使用手册或该设备的生产厂商的网站。若您的设备不支持eSIM，您则无法使用该服务。服务在购买后不能退费。",
  "Order.MaxLengthExceeded": "字段 {fieldName} 的最多字数为 {maxLength}",
  "Order.New": "订购一张新的SIM卡",
  "Order.OrderID": "订单号 {orderId}",
  "Order.PaymentDescr": "*价格不包含任何税费 支付金额将从您的MTX Connect 账户余额中扣除。",
  "Order.ProceedWithOrder": "and proceed with order",
  "Order.QuotaExceededCheckbox": "知道了",
  "Order.QuotaExceededConfirmation": "您账户下已经满10张卡了，您不能再激活新的卡了。<br /><br />如果您需要更多的卡，您可以创建一个新的账户，或者联系<a href=\"mailto:corp@mtxc.eu\">corp@mtxc.eu</a>，我们有更好的解决方案来帮您进行更多卡的管理。",
  "Order.SIMDescr": "三合一SIM卡价格€{price}",
  "Order.SimcardsLimitExceeded": "您账户中已有十张有效卡。<br /><br />如果您需要更多，您可创建一个新的账户，或者与<a href=\"mailto:corp@mtxc.eu\">corp@mtxc.eu</a>联系；我们将为您提供最佳方案以便进行多卡管理。",
  "Order.SmdpAddress": "SM-DP+ 地址",
  "Order.SuccPaymentCaption": "付款成功。您的订单已被接受！",
  "Order.SuccPaymentDescr": "您很快就会收到短信确认。{orderCaption}",
  "Order.UnsuccPaymentCaption": "付款失败",
  "Overview.ForSelectedCard": "For selected card only",
  "Overviews.Action": "操作",
  "Overviews.ActivationCodeUsed": "激活码为 <strong>{code}</strong> 的SIM卡已成功激活",
  "Overviews.ActiveSince": "激活时间：{date}",
  "Overviews.Date": "日期",
  "Overviews.Details": "细节",
  "Overviews.Left": "剩余",
  "Overviews.NoActivePackage": "无已激活套餐",
  "Overviews.NoAvailableTraffic": "无可用流量",
  "Overviews.NoTimeLeft": "无剩余时间",
  "Overviews.Remain": "剩余",
  "Overviews.RemainOf": "总共剩余{remain}",
  "Overviews.Spent": "已使用",
  "Overviews.TrafficLeft": "剩余流量",
  "Overviews.TrafficUsageHistory": "流量使用记录",
  "Overviews.UnlimitedTime": "不限时间",
  "Overviews.UnlimitedTraffic": "无限流量",
  "Overviews.UsageHistory": "使用记录",
  "Package.Accept": "接受",
  "Package.Active": "激活",
  "Package.AnotherPackageIsActive": "{activePackageName} 套餐在用。请等它失效",
  "Package.AutomaticRenewal": "Automatic renewal",
  "Package.AvailableCountries": "可选国家",
  "Package.AvailableNumbers": "可选号码",
  "Package.Back": "退回",
  "Package.BundlesLoadFailure": "无法加载套餐列表",
  "Package.CancelRenewal": "取消续订",
  "Package.CannotSwitchTariff": "套餐无法激活",
  "Package.ConfirmActivation": "<div>您即将激活SIM卡{cardName}的<b>{packageName}</b>套餐。</div>",
  "Package.ConfirmActivationMobileNumber": "<div>您即将为SIM卡{cardName}激活<b>MTX Number号码</b>。",
  "Package.ConfirmActivationSubscription": "<div>您即将开通您的 <b>{packageName}</b>。<br /><b>”免费聊天功能“将在这个卡{cardName}上开通。</b><br />如果您想在另一张卡上开通”免费聊天功能“，则请按“拒绝”，选择另一张卡并注册<b>{packageName}</b>。</div>",
  "Package.ConfirmAgreeCheckbox": "我知晓并同意。",
  "Package.ConfirmAgreeText": "MTX分配给你的MTX号码到期后将自动续期，对应费用将从您的账户余额中扣除 。请确认在号码到期之前您的账户有足够的余额。\n\n通过确认购买，您知晓MTX 号码不可代替您的直线电话号码，不可用于联系紧急服务或接收紧急服务信息，尤其是不能呼叫紧急服务。\n\n该服务是基于“现有可用“的基础上，意味着从某些移动网络、应用或其它第三方服务发送的SMS有可能无法送达。MTX Connect 不对MTX号码的适用性或可用性提供任何明示或暗示的保证。服务在购买后不能退费。",
  "Package.ConfirmAlertConsent": "请确认为SIM卡{cardName}购买的MTX 号码。",
  "Package.ConfirmAndPay": "确认并支付",
  "Package.ConfirmDeactivation": "<div>您即将关闭SIM卡{cardName}的<b>{packageName}</b>套餐。</div>",
  "Package.ConfirmDeactivationMobileNumber": "<div>您即将为SIM卡{cardName}取消<b>MTX 号码</b>。",
  "Package.Confirmation": "确认",
  "Package.ConnectPermanently": "永久联网",
  "Package.Day": "天",
  "Package.Decline": "拒绝",
  "Package.Done": "结束",
  "Package.EnableAnnualRenewal": "Enable automatic renewal",
  "Package.ExpiresDate": "到期日{date}",
  "Package.Gb": "Gb",
  "Package.GoingToStartRenewal": "MTX 为您分配的短信号码将使用您的账户余额或保存的支付卡自动续订相同期限。请确保在号码到期前您有足够的余额。",
  "Package.GoingToStopRenewal": "You are going to stop auto-renewal for MTX Number {number}.",
  "Package.Hour": "小时",
  "Package.IdentityIsNotApproved": "您的身份信息未能校验通过。请联系<a href=\"{link}\">客服</a>",
  "Package.IncludeVAT": "包含{currency} {difference}增值税",
  "Package.ListIsEmpty": "抱歉，无套餐可选",
  "Package.Mb": "MB",
  "Package.MobileNumberHeader": "给您的MTX SIM卡添加MTX号码",
  "Package.MobileNumberHint": "从MTX Connect 获取一个MTX号码，在世界各地都可以通过您的MTX SIM卡收取SMS。",
  "Package.MobileNumberLabel": "Annual subscription for inbound SMS and 2-way voice calls service.",
  "Package.MobileNumberPaymentHint": "支付金额将从您的MTX Connect 账户余额中扣除。",
  "Package.Number": "号码",
  "Package.PackageWillBeDeactivated": "<strong>警告!</strong> <strong>{packageName}</strong> 套餐将被停用!",
  "Package.PleaseTopup": "您的余额太低。请在充值页面{please_topup_page}",
  "Package.PleaseTopupPage": "充值",
  "Package.PreviousNumbers": "Previous Numbers",
  "Package.SelectNumber": "Select Number",
  "Package.StartRenewal": "Start Renewal",
  "Package.Subscribe": "订阅",
  "Package.Subscribed": "已订阅",
  "Package.SubscriptionActivationFailure": "无法激活套餐。请稍后再试。",
  "Package.SubscriptionDeactivationFailure": "无法取消激活套餐。请稍后再试。",
  "Package.Topup": "充值",
  "Package.TopupBalance": "充值",
  "Package.TrafficWillBeLost": "<strong>警告!</strong> {trafficRemain}当前套餐中的Mb将失效",
  "Package.Unsubscribe": "取消订阅",
  "Package.UnsubscribeWarning": "<p><b>警告：</b></p>\n<p>您订阅的自动续订将被取消。您仍旧可以在下一个计费日之前使用您的订阅。在这之后订阅将不再自动续费。</p>",
  "Package.perMb": "每MB",
  "Profile.ChangePassword": "修改密码",
  "Profile.ChangingPassword": "更改密码......",
  "Profile.ChooseIdentity": "选择上传文件",
  "Profile.City": "市",
  "Profile.CityHint": null,
  "Profile.Common": "常见的信息",
  "Profile.ConfirmNewPassword": "确认新密码",
  "Profile.CopiedToClipboard": "Copied to your clipboard",
  "Profile.Copy": "拷贝推荐链接",
  "Profile.Country": "国家",
  "Profile.CurrentPassword": "当前密码",
  "Profile.DeliveryAddress": "交付地址",
  "Profile.DeliveryType": "交货类型",
  "Profile.DetailedAddress": "详细地址",
  "Profile.District": "区",
  "Profile.Email": "电子邮件",
  "Profile.EmailAddress": "Email地址",
  "Profile.FirstName": "名",
  "Profile.FirstNameHint": null,
  "Profile.FloorUnit": "公寓",
  "Profile.FloorUnitHint": null,
  "Profile.GetRefferal": "获取推荐码",
  "Profile.IdentityPlaceholder": "上载您的身份证件扫描件",
  "Profile.IdentityStatus": "状态",
  "Profile.IdentityStatusAccepted": "已校验",
  "Profile.IdentityStatusLoaded": "上传完毕",
  "Profile.IdentityStatusPending": "等待上传",
  "Profile.IdentityStatusRejected": "上传无效",
  "Profile.IdentityStatusUnknown": "重新上传",
  "Profile.IdentityTitle": "上载身份证件",
  "Profile.LastName": "姓",
  "Profile.LastNameHint": null,
  "Profile.Login": "登录名",
  "Profile.NewPassword": "新密码",
  "Profile.NoIdentity": "未选择文件",
  "Profile.NonLatinError": "仅限于拉丁字母、数字及标点符号",
  "Profile.PasswordChangeFail": "密码修改失败",
  "Profile.PasswordChangeSuccess": "密码已修改",
  "Profile.PasswordsDontMatch": "密码不匹配",
  "Profile.Phone1": "电话号码",
  "Profile.PhoneHint": null,
  "Profile.PleaseFillNewPassword": "请输入新的密码",
  "Profile.PleaseFillPassword": "请输入当前密码",
  "Profile.Province": "省",
  "Profile.Referral": "推荐码",
  "Profile.Region": "省",
  "Profile.RegionHint": null,
  "Profile.Street": "街道",
  "Profile.StreetAndNumber": "街道及门牌号码",
  "Profile.StreetHint": null,
  "Profile.StreetNumber": "住所",
  "Profile.StreetUnit": "住房",
  "Profile.StreetUnitHint": null,
  "Profile.TermsOfServices": "按“下一步”按钮即表明我同意《<a href=\"https://mtxc.com.cn/cn/terms-and-conditions.html\" target=\"_blank\">条款与条件</a>》",
  "Profile.TheCurrentPasswordIsIncorrect": "The current password is incorrect",
  "Profile.UpdateFailed": "个人信息更新失败",
  "Profile.UpdateProfile": "更新个人信息",
  "Profile.UpdatedSuccessfully": "个人信息已成功更新!",
  "Profile.UpdatingProfile": "更新...",
  "Profile.UploadingIdentity": "Uploading:",
  "Profile.ZipCode": "邮编",
  "Shared.ActivePackage": "激活套餐",
  "Shared.ActiveTill": "至 {date} 有效",
  "Shared.AddSIM": "添加新的SIM卡",
  "Shared.ApiError": "糟糕，出错了。请",
  "Shared.ApiErrorLink": "重新加载页面",
  "Shared.Back": "返回",
  "Shared.BonusPackage": "奖励包",
  "Shared.CardIsSuspended": "该SIM卡已暂停服务。请与我们的<a href=\"{link}\">客服</a>联系重新开通服务。",
  "Shared.ConnectAndStartUsing": "请联网并开始使用流量",
  "Shared.CurrentPackageIs": "在用套餐{packageName} 到{date}有效",
  "Shared.ErrorGettingTestSmsCount": "测试SMS接收失败",
  "Shared.ErrorLoadingPage": "加载页面时出错",
  "Shared.ErrorPhoneMsg": "Please use valid phone number",
  "Shared.FillAllAddressFields": "所有空格必填",
  "Shared.Location": "位置",
  "Shared.NextPackage": "下一个套餐",
  "Shared.PackageToBeActive": "在欧洲生效的套餐: ",
  "Shared.Rename": "重命名",
  "Shared.Sure": "确定吗？",
  "Shared.Suspend": "暂停使用",
  "Shared.TestSmsButton": "测试SMS",
  "Shared.TestSmsLeft": "测试 {left} 条SMS 短信剩余",
  "Shared.Unsuspend": "需要发邮件给 <a href=\"mailto:help@mtxc.eu\">help@mtxc.eu</a> 申请才可取消暂停",
  "Shared.UploadError": "上载失败。请将您的身份证明发送邮件至 support@mtxc.eu",
  "Shared.UploadWrongFormat": "文档应是 jpg 格式",
  "Simcards.ActivateSIM": "激活SIM",
  "Simcards.ActivateSimCard": "要使用控制面板，请先激活 SIM 卡",
  "Simcards.EmptyActivationCode": "请输入激活号码",
  "Simcards.EnterCode": "请在以下输入激活号码",
  "Simcards.ErrorLoadingPrices": "Failed to load prices",
  "Simcards.FindActivationCode": "在您的MTXC SIM卡背面可以找到激活号码:",
  "Simcards.SimcardNotActivated": "无法激活 SIM 卡",
  "Simcards.WrongFormatActivationCode": "激活码无效",
  "Support.Buffered": "您的信息已发送到我们的客服。我们将尽快回复。回复信息会发送到您的email 和您的个人账户。",
  "Support.BufferedCn": "您的信息已发送到我们的客服。我们将尽快回复。回复信息会发送到您的email 或者 SMS。",
  "Support.CreateCommentError": "无法创建评论。请稍后再试，或给 support@mtxc.eu 发送电子邮件与我们联系",
  "Support.CreateTicketError": "无法创建工单。请稍后再试，或给 support@mtxc.eu 发送电子邮件与我们联系",
  "Support.Date": "日期",
  "Support.LoadMoreBtn": "装载更多",
  "Support.Message": "信息",
  "Support.Send": "发送",
  "Support.Sending": "发送......",
  "Support.Topic": "主题",
  "TermsAnPrivacy": "By clicking <b>\"Accept\"</b>, I certify that agree to the <a href=\"{terms_url}\" target=\"_blank\"><b>Terms and Conditions</b></a> and <a href=\"{privacy_url}\" target=\"_blank\"><b>Privacy Policy</b></a>.",
  "Topup.AliPay": "支付宝",
  "Topup.AliPayRedirecting": "重定向到支付宝......",
  "Topup.AliPayWarning": "通过支付宝进行的支付有可能会延迟（最多不超过24小时）。<br />若您需要马上获得交易结果，请选择其它的支付方式。",
  "Topup.Amount": "充值金额",
  "Topup.AmountTitle": "Top-up amount, €",
  "Topup.AmountWord": "金额{amount} {currency}",
  "Topup.ApplePayBtn": "Buy with",
  "Topup.ByCard": "信用卡",
  "Topup.CVC": "CVC",
  "Topup.CardCvv": "Please enter CVV:",
  "Topup.CardDetails": "Card details:",
  "Topup.CardHolderName": "CARDHOLDER NAME",
  "Topup.CardNew": "New card",
  "Topup.CardNumber": "卡号",
  "Topup.CardSaved": "Saved cards",
  "Topup.EnterVoucherCode": "输入充值券代码",
  "Topup.ExchangeNotice": "因MTX结算货币为欧元，由于汇率的原因，实际支付额可能会有稍微不同。若有疑议，请联系客服。",
  "Topup.GettingToken": "开启支付...",
  "Topup.InsufficientFunds": "Insufficient funds",
  "Topup.MM": "月",
  "Topup.MakePayment": "支付",
  "Topup.Megapay": "123",
  "Topup.PaidWith": "使用{paymentMethod}进行支付",
  "Topup.PayByVoucher": "使用充值券支付",
  "Topup.PayPal": "PayPal",
  "Topup.PayPalPayment": "使用支付宝进行支付",
  "Topup.PayPalProceed": "使用支付宝支付 {amount} {currency_code}",
  "Topup.PaymentInProgress": "正在进行支付...",
  "Topup.RefillCard": "支付失败。请重新输入您的支付信息。因为我们更换了支付网关，您需要重新添加您的支付卡以便进行充值。",
  "Topup.RememberCard": "记住此卡",
  "Topup.Saving": "正在保存......",
  "Topup.SpecifyAddress": "请在付款前写明账单地址",
  "Topup.StoredCard.EnterCVV": "请输入 CCV 码",
  "Topup.StoredCard.Pay": "支付",
  "Topup.StoredCard.StoredCards": "已保存的卡",
  "Topup.StoredCard.UseCard": "使用该卡",
  "Topup.SubmittingCode": "提交密码...",
  "Topup.SuccessfulPaymentDescrEmail": "您将很快收到一份电子邮件确认。",
  "Topup.SuccessfulPaymentDescrSMS": "您将很快收到一份手机短信确认。",
  "Topup.SuccessfulPaymentHeader": "付款成功，已接受您的订单！",
  "Topup.SuccessfulPaymentPayAgain": "再次支付",
  "Topup.SuccessfulPaymentTransaction": "交易代号： {transactionId}",
  "Topup.SuccessfulPaymentTryAgain": "请再次尝试",
  "Topup.TakeCareText": "为了保障用户的安全，我们从不保存任何支付卡的信息。",
  "Topup.UnsuccessfulPaymentHeader": "注意！支付不成功！",
  "Topup.UseCardToAutoSubscriptionRenewal": "Use this card for automatic subscription renewal if there are insufficient funds",
  "Topup.UseCardToAutoTopup": "Use this card for automatic top-up when the balance falls below €2",
  "Topup.ValidThru": "到期",
  "Topup.Voucher": "充值券",
  "Topup.YY": "年",
  "autorenew.subscription.disable": "您将停止 {name} 订阅的自动续订。",
  "autorenew.subscription.enable": "{name} 订阅将使用您的账户余额或保存的支付卡自动续订相同期限。请确保在订阅到期前您有足够的余额。",
}



// WEBPACK FOOTER //
// ./app/javascript/components/locales/zh.js